<div class="flex justify-between">
  <nz-input-group
    class="w-1/2 pb-5"
    nzSearch
    nzSize="large"
    [nzAddOnAfter]="suffixIconButton"
    ><input
      #searchInput
      [(ngModel)]="searchValue"
      type="text"
      nz-input
      placeholder="Suchen Sie hier nach Inventarisierungsnummern"
      (keydown.enter)="onSearch()"
    />
  </nz-input-group>
  <ng-template #suffixIconButton>
    <button (click)="onSearch()" nz-button nzType="primary" nzSearch>
      <span nz-icon nzType="search"></span>
    </button>
  </ng-template>
  <app-main-button (click)="navigateToNew()">Kleidung anlegen</app-main-button>
</div>
<nz-table
  *ngIf="!loading"
  #filterTable
  [nzData]="displayedClothing"
  nzSize="middle"
  nzTableLayout="auto"
  [nzFrontPagination]="true"
  [nzPageIndex]="1"
  (nzQueryParams)="onTableQueryParamsChange($event)"
>
  <thead>
    <tr>
      <th
        *ngFor="let column of listOfColumns"
        [(nzSortOrder)]="column.sortOrder"
        [nzSortFn]="column.sortFn"
        [nzFilters]="column.listOfFilter"
        [nzFilterFn]="column.filterFn"
        [nzShowFilter]="!!column.filterFn"
      >
        {{ column.name }}
      </th>
      <th nzCustomFilter>
        Kleidergröße
        <nz-filter-trigger
          [(nzVisible)]="searchSizeVisible"
          [nzActive]="!!searchSizeValue"
          [nzDropdownMenu]="menu"
        >
          <span nz-icon nzType="search"></span>
        </nz-filter-trigger>
      </th>
    </tr>
  </thead>
  <tbody>
    <tr
      *ngFor="let data of filterTable.data"
      class="clickable-row"
      (click)="onClothingClick(data)"
    >
      <td>{{ data.inventarnummer }}</td>
      <td>{{ data.bezeichnung }}</td>
      <td>{{ data.statusText }}</td>
      <td>{{ data.kleidergroesseText }}</td>
    </tr>
  </tbody>
</nz-table>
<nz-dropdown-menu #menu="nzDropdownMenu">
  <div class="ant-table-filter-dropdown">
    <div class="search-box">
      <input
        type="text"
        nz-input
        placeholder="Search name"
        [(ngModel)]="searchSizeValue"
        (keydown.enter)="searchSize()"
      />
      <button
        nz-button
        nzSize="small"
        nzType="primary"
        (click)="searchSize()"
        class="search-button"
      >
        Search
      </button>
      <button nz-button nzSize="small" (click)="resetSize()">Reset</button>
    </div>
  </div>
</nz-dropdown-menu>

<nz-spin
  *ngIf="loading"
  nzSize="large"
  nzTip="Lade Kleidung..."
  style="padding-top: 50%"
>
</nz-spin>
